package org.catharsis.spendtel.feature.presentation.web

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController

@Composable
actual fun LandingScreen(navHostController: NavHostController) {
    WebLandingScreen(navHostController = navHostController)
}
